import { Box } from '@chakra-ui/react';
import type { ReactElement } from 'react';

import type { NavItemConfig } from '@revelio/auth';

import styles from './side-nav.module.css';

const isReactIcon = (icon: NavItemConfig['icon']): icon is ReactElement =>
  Boolean(icon) && typeof icon !== 'string';

export const navIconBg = (icon: NavItemConfig['icon']) =>
  typeof icon === 'string' ? `url(${icon})` : undefined;

export const NavIconChild = ({ icon }: { icon: NavItemConfig['icon'] }) => {
  if (isReactIcon(icon)) {
    return (
      <Box
        position="absolute"
        inset="0"
        color="var(--rl-sidenav-icon-color, white)"
        pointerEvents="none"
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={styles.reactNavIcon}
      >
        {icon}
      </Box>
    );
  }

  if (typeof icon === 'string') {
    return (
      <Box
        position="absolute"
        inset="0"
        pointerEvents="none"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          as="span"
          className={styles.maskIcon}
          sx={{
            maskImage: `url("${icon}")`,
            WebkitMaskImage: `url("${icon}")`,
          }}
        />
      </Box>
    );
  }

  return null;
};
